import React from 'react';

const Adverbs = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">What is an Adverb? (Èpón)</div>

      <p className="gadject-body">
        An Adverb simply is a word that modifies an adjective, verb, or other adverb or a word group{' '}
        <br />
        For example;
      </p>
      <div className="gadject-example">
        <div className="gadject-text">
          <p className="gadject-eng">YESTERDAY was my birthday</p>
          <p className="gadject-eng">ÀNÁ ní ọjó-ìbí mí</p>
        </div>
        <div className="gadject-text">
          <p className="gadject-eng">Bolu is VERY tall</p>
          <p className="gadject-eng">Bolu ga PUPỌ</p>
        </div>
      </div>
      <div className="gadject-footer">
        The adverbs are ÀNÁ and PUPỌ, it modifies the preposition was (ní) and adjective tall (ga)
      </div>
      <div className="gadject-footer">
        On our trip we will be learning Adverb of time, manner and place
      </div>
    </div>
  );
};

export default Adverbs;
